module.exports = __webpack_public_path__ + "static/4-b97ec028c1dae1200ffb7a6e67b66f97.png";